<template>
  <div v-if="!value && address">
    <v-layout wrap>
      <v-flex xs12 sm6 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('name') }">
          <div>{{ $t('first name') }} - {{ $t('last name') }} / {{ $t('Company Name') }}</div>

          <input
            v-model="address.name"
            name="name"
            type="text"
            :placeholder="$t('name')"
            v-validate="{
              required: true
            }"
          />

          <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('phone') }">
          <div>{{ $t('Tel') }}</div>

          <input
            v-model="address.tel"
            name="phone"
            type="tel"
            :placeholder="$t('Tel')"
            v-validate="{
              required: true
            }"
          />

          <span class="text-error" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
        </div>
      </v-flex>
      <v-flex xs12 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('addressno') }">
          <div>{{ $t('Address No.') }}</div>
          <div class="form-control">
            <textarea
              style="width: 100%; min-height: 60px"
              v-model="address.addressno"
              :data-vv-as="$t('Address No.')"
              v-validate="'required'"
              name="addressno"
              :placeholder="$t('fill Address No., Building, Village, Soi, or Road')"
            ></textarea>
          </div>

          <span class="text-error" v-if="errors.has('addressno')">{{
            errors.first('addressno')
          }}</span>
        </div>
      </v-flex>

      <v-flex xs12 sm6 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('zipcode') }">
          <div>{{ $t('Postcode') }}</div>
          <thai-address-input
            v-model="address.postcode"
            type="zipcode"
            @select="onSelectAddress"
            :placeholder="$t('Postcode')"
          />
          <input
            type="hidden"
            name="zipcode"
            :data-vv-as="$t('Postcode')"
            v-model="address.postcode"
            v-validate="'required'"
          />

          <span class="text-error" v-if="errors.has('zipcode')">{{ errors.first('zipcode') }}</span>
        </div>
      </v-flex>

      <v-flex xs12 sm6 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('sub_district') }">
          <div>{{ $t('Subdistrict') }}</div>
          <thai-address-input
            v-model="address.sub_district"
            type="district"
            @select="onSelectAddress"
            :placeholder="$t('Subdistrict')"
          />
          <input
            type="hidden"
            name="sub_district"
            :data-vv-as="$t('Subdistrict')"
            v-model="address.sub_district"
            v-validate="'required'"
          />

          <span class="text-error" v-if="errors.has('sub_district')">{{
            errors.first('sub_district')
          }}</span>
        </div>
      </v-flex>

      <v-flex xs12 sm6 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('amphoe') }">
          {{ $t('District') }}
          <thai-address-input
            v-model="address.district"
            type="amphoe"
            @select="onSelectAddress"
            :placeholder="$t('District')"
          />
          <input
            type="hidden"
            name="amphoe"
            :data-vv-as="$t('District')"
            v-model="address.district"
            v-validate="'required'"
          />
          <div></div>

          <span class="text-error" v-if="errors.has('amphoe')">{{ errors.first('amphoe') }}</span>
        </div>
      </v-flex>

      <v-flex xs12 sm6 class="px-1">
        <div class="form-control" :class="{ 'has-error': errors.has('province') }">
          <div>{{ $t('Province') }}</div>
          <thai-address-input
            v-model="address.province"
            type="province"
            @select="onSelectAddress"
            :placeholder="$t('Province')"
          />
          <input
            type="hidden"
            name="province"
            :data-vv-as="$t('Province')"
            v-model="address.province"
            v-validate="'required'"
          />

          <span class="text-error" v-if="errors.has('province')">{{
            errors.first('province')
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <template
      v-if="
        Object.prototype.hasOwnProperty.call(selectedBot, 'shippop_status') &&
        selectedBot.shippop_status == true
      "
    >
      <v-divider />
      <v-checkbox
        v-model="hasReturnAddress"
        :label="`ต้องการเปลี่ยนที่อยู่ผู้ส่ง`"
        color="primary"
      ></v-checkbox>
      <template v-if="hasReturnAddress">
        <v-layout wrap>
          <v-flex xs12 sm6 class="px-1">
            <div class="form-control" :class="{ 'has-error': errors.has('returnAddress.name') }">
              <div>{{ $t('first name') }} - {{ $t('last name') }} / {{ $t('Company Name') }}</div>

              <input
                v-model="returnAddress.name"
                name="returnAddress.name"
                type="text"
                :data-vv-as="$t('name')"
                :placeholder="$t('name')"
                v-validate="{
                  required: true
                }"
              />

              <span class="text-error" v-if="errors.has('returnAddress.name')">{{
                errors.first('returnAddress.name')
              }}</span>
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="px-1">
            <div class="form-control" :class="{ 'has-error': errors.has('returnAddress.phone') }">
              <div>{{ $t('Tel') }}</div>

              <input
                v-model="returnAddress.tel"
                name="returnAddress.phone"
                type="tel"
                :placeholder="$t('Tel')"
                :data-vv-as="$t('Tel')"
                v-validate="{
                  required: true
                }"
              />

              <span class="text-error" v-if="errors.has('returnAddress.phone')">{{
                errors.first('returnAddress.phone')
              }}</span>
            </div>
          </v-flex>
          <v-flex xs12 class="px-1">
            <div
              class="form-control"
              :class="{ 'has-error': errors.has('returnAddress.addressno') }"
            >
              <div>{{ $t('Address No.') }}</div>
              <div class="form-control">
                <textarea
                  style="width: 100%; min-height: 60px"
                  v-model="returnAddress.addressno"
                  :data-vv-as="$t('Address No.')"
                  v-validate="'required'"
                  name="returnAddress.addressno"
                  :placeholder="$t('fill Address No., Building, Village, Soi, or Road')"
                ></textarea>
              </div>

              <span class="text-error" v-if="errors.has('returnAddress.addressno')">{{
                errors.first('returnAddress.addressno')
              }}</span>
            </div>
          </v-flex>

          <v-flex xs12 sm6 class="px-1">
            <div class="form-control" :class="{ 'has-error': errors.has('returnAddress.zipcode') }">
              <div>{{ $t('Postcode') }}</div>
              <thai-address-input
                v-model="returnAddress.postcode"
                type="zipcode"
                @select="onSelectReturnAddress"
                :placeholder="$t('Postcode')"
              />
              <input
                type="hidden"
                name="returnAddress.zipcode"
                :data-vv-as="$t('Postcode')"
                v-model="returnAddress.postcode"
                v-validate="'required'"
              />

              <span class="text-error" v-if="errors.has('returnAddress.zipcode')">{{
                errors.first('returnAddress.zipcode')
              }}</span>
            </div>
          </v-flex>

          <v-flex xs12 sm6 class="px-1">
            <div
              class="form-control"
              :class="{ 'has-error': errors.has('returnAddress.sub_district') }"
            >
              <div>{{ $t('Subdistrict') }}</div>
              <thai-address-input
                v-model="returnAddress.sub_district"
                type="district"
                @select="onSelectReturnAddress"
                :placeholder="$t('Subdistrict')"
              />
              <input
                type="hidden"
                name="returnAddress.sub_district"
                :data-vv-as="$t('Subdistrict')"
                v-model="returnAddress.sub_district"
                v-validate="'required'"
              />

              <span class="text-error" v-if="errors.has('returnAddress.sub_district')">{{
                errors.first('returnAddress.sub_district')
              }}</span>
            </div>
          </v-flex>

          <v-flex xs12 sm6 class="px-1">
            <div class="form-control" :class="{ 'has-error': errors.has('returnAddress.amphoe') }">
              {{ $t('District') }}
              <thai-address-input
                v-model="returnAddress.district"
                type="amphoe"
                @select="onSelectReturnAddress"
                :placeholder="$t('District')"
              />
              <input
                type="hidden"
                name="returnAddress.amphoe"
                :data-vv-as="$t('District')"
                v-model="returnAddress.district"
                v-validate="'required'"
              />
              <div></div>

              <span class="text-error" v-if="errors.has('returnAddress.amphoe')">{{
                errors.first('returnAddress.amphoe')
              }}</span>
            </div>
          </v-flex>

          <v-flex xs12 sm6 class="px-1">
            <div
              class="form-control"
              :class="{ 'has-error': errors.has('returnAddress.province') }"
            >
              <div>{{ $t('Province') }}</div>
              <thai-address-input
                v-model="returnAddress.province"
                type="province"
                @select="onSelectReturnAddress"
                :placeholder="$t('Province')"
              />
              <input
                type="hidden"
                name="returnAddress.province"
                :data-vv-as="$t('Province')"
                v-model="returnAddress.province"
                v-validate="'required'"
              />

              <span class="text-error" v-if="errors.has('returnAddress.province')">{{
                errors.first('returnAddress.province')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
      </template>
    </template>

    <div class="text-xs-center">
      <v-btn color="grey" outline @click="onClose" :loading="loading">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" depressed @click="onAdd" :loading="loading">{{ $t('Save') }}</v-btn>
    </div>

    <div style="clear: both"></div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ThaiAddressInput from '@/components/elements/ThaiAddressInput'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          addressno: '',
          tel: '',
          postcode: '',
          sub_district: '',
          district: '',
          province: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  components: {
    ThaiAddressInput
  },
  data() {
    return {
      address: null,
      loading: false,

      hasReturnAddress: false,
      returnAddress: {
        name: '',
        addressno: '',
        tel: '',
        postcode: '',
        sub_district: '',
        district: '',
        province: ''
      }
    }
  },
  mounted() {
    if (this.data.hasOwnProperty('returnAddress')) {
      this.hasReturnAddress = true
      this.returnAddress = cloneDeep(this.data.returnAddress)
    }

    this.address = this.data
  },
  methods: {
    onClose() {
      this.$emit('input', true)
    },
    async onAdd() {
      var vm = this
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true

      var address = cloneDeep(this.address)
      if (this.hasReturnAddress) {
        address.returnAddress = cloneDeep(this.returnAddress)
      } else {
        if (address.hasOwnProperty('returnAddress')) delete address.returnAddress
      }

      this.$emit('saveAddress', {
        address: this.address,
        oncomplete: function () {
          vm.$emit('input', true)
          vm.loading = false
        }
      })
    },

    onSelectAddress(address) {
      this.address.sub_district = address.district
      this.address.district = address.amphoe
      this.address.province = address.province
      this.address.postcode = address.zipcode
    },
    onSelectReturnAddress(address) {
      this.returnAddress.sub_district = address.district
      this.returnAddress.district = address.amphoe
      this.returnAddress.province = address.province
      this.returnAddress.postcode = address.zipcode
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/AddressManage.vue